export default __webpack_public_path__ + "static/media/play.df66af08.svg";